import type React from "react";
import { useRef, useState } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Textfield } from "@similarweb/ui-components";

import { StyledTextFieldError, StyledTextFieldLabel } from "./styles";

type Props = {
    placeholder: string;
    label: string;
    validate?: (value: string) => boolean;
    onUpdate: (value: string) => void;
};

export const TextField: React.FC<Props> = ({ onUpdate, placeholder, label, validate }) => {
    const { translate } = useTranslate();

    const [value, setValue] = useState("");
    const [isError, setIsError] = useState(false);
    const inputRef = useRef<Textfield>(null);

    const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key !== "Enter") {
            return;
        }

        const isValid = validate ? validate(value) : true;

        if (!value || !isValid) {
            setIsError(true);
            return;
        }

        inputRef.current?.clearValue();
        onUpdate(value);
    };

    const handleChange = (newValue: string) => {
        if (newValue) {
            setIsError(false);
        }

        setValue(newValue);
    };

    const handleCloseClick = () => {
        setValue("");
        inputRef.current?.clearValue();
    };

    return (
        <>
            <Textfield
                onChange={handleChange}
                ref={inputRef}
                error={isError}
                onKeyUp={handleKeyUp}
                onCloseClick={handleCloseClick}
                placeholder={placeholder}
                onBlur={() => setIsError(false)}
                className="text-field"
            />
            {label && !isError ? <StyledTextFieldLabel>{label}</StyledTextFieldLabel> : null}
            {isError ? (
                <StyledTextFieldError>
                    {translate("si.find_apps.filters.identifier.android.validation.error")}
                </StyledTextFieldError>
            ) : null}
        </>
    );
};
